import ComparisonsList from "@/pages/ComparisonsList";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/assessments/static/comparisons")({
  component: ComparisonsList,
});
